import React from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Button,
  Grid,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from "@mui/material";

const AddVersusPackDialog = ({
  open,
  onClose,
  versusPackType,
  setVersusPackType,
  addVersusPackHandler,
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">
        Add Versus Contract Pack
      </DialogTitle>
      <DialogContent>
        <Grid container>
          <Grid item xs={12} sx={{ m: 0, p: 1 }}>
            <FormControl fullWidth variant="standard">
              <InputLabel id="store-select-label">Pack Type</InputLabel>
              <Select
                labelId="store-select-label"
                id="store-select"
                value={versusPackType}
                label="Store"
                onChange={(e) => setVersusPackType(e.target.value)}
              >
                <MenuItem value="0">Daily Challange Pack</MenuItem>
                <MenuItem value="1">5 Contracts Pack</MenuItem>
                <MenuItem value="2">12 Contracts pack</MenuItem>
              </Select>
            </FormControl>
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button onClick={addVersusPackHandler} autoFocus disabled={false}>
          Add
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AddVersusPackDialog;
